import { render, staticRenderFns } from "./DeleteDomain.vue?vue&type=template&id=677ecfef&"
import script from "./DeleteDomain.vue?vue&type=script&lang=js&"
export * from "./DeleteDomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('677ecfef')) {
      api.createRecord('677ecfef', component.options)
    } else {
      api.reload('677ecfef', component.options)
    }
    module.hot.accept("./DeleteDomain.vue?vue&type=template&id=677ecfef&", function () {
      api.rerender('677ecfef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/modules/AccountSettings/Pages/Routes/Player/Modal/DeleteDomain.vue"
export default component.exports